<template>
<Card   :padding="0" :bordered="myConfig.bordered" dis-hover style="width:100%;overflow-x:hidden;padding:14px;16px;">
    <Input v-if="showCondition" ref="condition" :placeholder="searchPlaceholder"  v-model="searchValue"  search style="width: 100%;margin-top:10xp;margin-bottom:10px" @on-search="search" @on-enter="search"/>
    <div class="customLayout" :style="style">
        <Tree ref="tree" v-show="showTree" :data="treeData" :class="myConfig.className" :show-checkbox="myConfig.showCheckBox"  @on-select-change="onSelectChange" @on-check-change="onCheckChange" @on-toggle-expand="onToggleExpand"/>
        <SimpleViewGrid v-show="!showTree" ref="grid"  :config="gridConfig"  :dictData="dictData" @dbclick="dbclick"/>
    </div>
</Card>
</template>
<script>
    import Base from '@/components/tree/treedatabase.vue';
    import elementResizeDetectorMaker from 'element-resize-detector';
    export default {
        name:'treedata',
        extends: Base,
        data () {
            return {
                searchPlaceholder:'请输入编码或名称',
                searchValue:''
            }
        },
        created () {
            this.init();
            if (!this.gridConfig) {
               this.gridConfig = {};     
            }
            if (this.myConfig.items) {
                this.gridConfig.items = this.$Method.copy(this.myConfig.items);
            } else {
                if (!this.gridConfig.items) {
                   this.gridConfig.items = []; 
                }
                let code = {
                    label:'编码',
                    name:this.myConfig.responseCode,
                    type:'TextBox',
                }
                let name = {
                    label:'名称',
                    name:this.myConfig.responseName,
                    type:'TextBox',
                }
                this.gridConfig.items.push(code);
                this.gridConfig.items.push(name);
            }
        },
        methods: {
            search () {
                if (!this.searchValue) {
                    this.refurbish();
                    this.showTree = true;
                } else {
                    let tmp = [];
                    this.data.forEach(el => {
                        if(el[this.myConfig.responseCode].indexOf(this.searchValue) > -1 || el[this.myConfig.responseName].indexOf(this.searchValue) > -1) {
                            tmp.push(el);
                        }
                    });
                    this.$refs.grid.setData(tmp);
                    this.showTree = false;
                }
            },
            setTreeNodeIcon(params,obj) {
                if (params.node.children.length > 0) {
                    if (params.data.expand) {
                        obj.type = '_custom-wenjianzhankai';
                    } else {
                        obj.type = '_custom-wenjianshouqi';
                    }
                } else {
                    obj.type = '_custom-yemian';
                }
                return obj;
            }
        },
        mounted () {
            this.observer = elementResizeDetectorMaker();
            this.observer.listenTo(this.$refs.condition, this.setExtraHeight);
        },
        beforeDestroy() {
            this.observer.removeListener(this.$refs.condition, this.setExtraHeight);
        }
    };
</script>

<style>
.customLayout{
    OVERFLOW-Y: auto; 
    /*background: url('./images/bg.jpg') no-repeat 4px 5px;*/
}
</style>




// WEBPACK FOOTER //
// src/components/masterplate/simpletree.vue